import styled from '@emotion/styled';

import { inputBaseStyles } from '@/components/common/form/controlStyles';

export const SearchInputBox = styled.div`
	position: relative;
	width: 100%;
	max-width: 33.5rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
`;

export const IconWrapper = styled.div`
	position: absolute;
	left: 1.6rem;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
	pointer-events: none;

	svg {
		width: 2rem;
		height: 2rem;
		color: ${(props) => props.theme.ui.text.muted};
	}
`;

export const SearchInput = styled.input`
	${(props) => inputBaseStyles(props.theme)};
	padding-left: 4.8rem;
`;
